import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';

interface IProps {
  quote: string;
}

const TestimonialSingleQuote = ({ quote }: IProps): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$testimonialsSection' });

  return (
    <section className="testimonials-stacked">
      <div className="testimonials-stars">
        {/* TODO: replace hearts with icons when new icons are ready */}
        <div className="testimonials-star">&#9733;</div>
        <div className="testimonials-star">&#9733;</div>
        <div className="testimonials-star">&#9733;</div>
        <div className="testimonials-star">&#9733;</div>
        <div className="testimonials-star">&#9733;</div>
      </div>
      <div className="testimonials-quote" dangerouslySetInnerHTML={{ __html: quote }} />
    </section>
  );
};

export default TestimonialSingleQuote;
